export default __webpack_public_path__ + "static/media/HD1.7d7e6485.png";